// `wp` (wp-dom-ready etc.) isn't enqueued on every page this file runs on (e.g. my-account/view-order) -
// relying on `wp.domReady` there throws a ReferenceError that halts the rest of this bundled script,
// silently breaking every domReady block below it. Use a dependency-free equivalent instead.
const domReady = ( callback ) => {
	if ( document.readyState !== 'loading' ) {
		callback();
	} else {
		document.addEventListener( 'DOMContentLoaded', callback );
	}
};

domReady( () => {
	const account_btn_elem = document.querySelector( '.header-account-button' );
	if ( account_btn_elem ) {
		account_btn_elem.ariaLabel  = "Account";
	}
} );

domReady( () => {
	const message = window.birnnOosRemovedNotice;
	const noticesContainer = document.querySelector( '.wc-block-components-notices' );
	if ( ! message || ! noticesContainer ) return;

	const banner = document.createElement( 'div' );
	banner.className = 'wc-block-store-notice wc-block-components-notice-banner is-info';
	banner.innerHTML = `
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false"><path d="M12 3.2c-4.8 0-8.8 3.9-8.8 8.8 0 4.8 3.9 8.8 8.8 8.8 4.8 0 8.8-3.9 8.8-8.8 0-4.8-4-8.8-8.8-8.8zm0 16c-4 0-7.2-3.3-7.2-7.2C4.8 8 8 4.8 12 4.8s7.2 3.3 7.2 7.2c0 4-3.2 7.2-7.2 7.2zM11 17h2v-6h-2v6zm0-8h2V7h-2v2z"></path></svg>
		<div class="wc-block-components-notice-banner__content"><div></div></div>
	`;
	banner.querySelector( '.wc-block-components-notice-banner__content div' ).textContent = message;
	noticesContainer.prepend( banner );
} );

domReady( () => {
	const checkoutNode = document.querySelector( '.wp-block-woocommerce-checkout' );

	if ( checkoutNode ) {
		const observer = new MutationObserver( () => {
			const step_description = document.querySelector( '.wc-block-checkout__payment-method .wc-block-components-radio-control .wc-block-components-radio-control-accordion-content:not(:has(.on-file-payment_description)) > :first-child' );
			if ( step_description ) {
				observer.disconnect();
				step_description.classList.add("on-file-payment_description");
				step_description.parentElement.insertAdjacentElement( 'beforeend', step_description );
				observer.observe( checkoutNode, { childList: true, subtree: true } );
			}
		} );
		observer.observe( checkoutNode, { childList: true, subtree: true } );
	}
} );


domReady( () => {
	document.querySelectorAll( '.birnn-invoice-actions' ).forEach( ( actions_elem ) => {
		const ajax_url = actions_elem.dataset.ajaxUrl;
		const status_elem = actions_elem.querySelector( '.birnn-invoice-status' );

		const print_btn = actions_elem.querySelector( '[data-invoice-action="print"]' );
		if ( print_btn ) {
			print_btn.addEventListener( 'click', () => {
				const details_section = actions_elem.closest( '.woocommerce-order-details' );
				if ( ! details_section ) {
					return;
				}
				const customer_section = details_section.nextElementSibling?.classList.contains( 'woocommerce-customer-details' )
					? details_section.nextElementSibling
					: null;

				const print_node = document.createElement( 'div' );
				print_node.id = 'birnn-print-invoice';
				print_node.appendChild( details_section.cloneNode( true ) );
				if ( customer_section ) {
					print_node.appendChild( customer_section.cloneNode( true ) );
				}
				document.body.appendChild( print_node );
				document.body.classList.add( 'birnn-printing-invoice' );

				window.onafterprint = () => {
					document.body.classList.remove( 'birnn-printing-invoice' );
					print_node.remove();
					window.onafterprint = null;
				};
				window.print();
			} );
		}

		const email_btn = actions_elem.querySelector( '[data-invoice-action="email"]' );
		if ( email_btn ) {
			email_btn.addEventListener( 'click', () => {
				email_btn.disabled = true;
				status_elem.textContent = '';

				fetch( ajax_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
					body: new URLSearchParams( {
						action: 'birnn_email_invoice',
						order_id: email_btn.dataset.orderId,
						nonce: email_btn.dataset.nonce,
					} ),
				} )
					.then( ( response ) => response.json() )
					.then( ( result ) => {
						status_elem.textContent = result?.data?.message ?? '';
					} )
					.catch( () => {
						status_elem.textContent = 'Something went wrong. Please try again.';
					} )
					.finally( () => {
						email_btn.disabled = false;
					} );
			} );
		}
	} );
} );

domReady( () => {
	const checkoutNode = document.querySelector( '.wp-block-woocommerce-checkout' );
	if ( ! checkoutNode ) return;

	const TOOLTIP_ID = 'order-summary-edit-tooltip';

	function addEditTooltip( titleText ) {
		if ( titleText.nextElementSibling?.classList.contains( 'order-summary-edit-trigger' ) ) return;

		const trigger = document.createElement( 'button' );
		trigger.type = 'button';
		trigger.className = 'order-summary-edit-trigger';
		trigger.textContent = 'Edit';
		trigger.setAttribute( 'popovertarget', TOOLTIP_ID );
		// the title row doubles as a mobile accordion toggle - stop the click from
		// bubbling up and collapsing the panel instead of opening the tooltip
		trigger.addEventListener( 'click', ( event ) => event.stopPropagation() );
		titleText.insertAdjacentElement( 'afterend', trigger );

		const tooltip = document.createElement( 'div' );
		tooltip.id = TOOLTIP_ID;
		tooltip.className = 'order-summary-edit-tooltip';
		tooltip.setAttribute( 'popover', '' );
		tooltip.textContent = 'Click on a product to edit your order.';
		document.body.appendChild( tooltip );

		const { computePosition, offset, shift, autoPlacement } = window.FloatingUIDOM;
		tooltip.addEventListener( 'toggle', ( event ) => {
			if ( event.newState !== 'open' ) return;
			computePosition( trigger, tooltip, {
				placement: 'top-end',
				middleware: [ offset( 8 ), shift( { padding: 8 } ), autoPlacement( { allowedPlacements: [ 'top-end', 'bottom-end', 'top', 'bottom' ] } ) ],
			} ).then( ( { x, y } ) => {
				Object.assign( tooltip.style, { left: `${ x }px`, top: `${ y }px` } );
			} );
		} );
	}

	function linkProductNamesToCategories() {
		const links = window.birnnCheckoutCategoryLinks || {};
		document.querySelectorAll( '.wc-block-components-order-summary-item .wc-block-components-product-name' ).forEach( ( nameEl ) => {
			if ( nameEl.querySelector( 'a' ) ) return;
			const categoryLink = links[ nameEl.textContent.trim() ];
			if ( ! categoryLink ) return;
			const link = document.createElement( 'a' );
			link.href = categoryLink;
			link.textContent = nameEl.textContent;
			nameEl.textContent = '';
			nameEl.appendChild( link );
		} );
	}

	function prefixProductNamesWithSku() {
		const skus = window.birnnCheckoutSkus || {};
		document.querySelectorAll( '.wc-block-components-order-summary-item .wc-block-components-product-name' ).forEach( ( nameEl ) => {
			if ( nameEl.querySelector( '.order-summary-item-sku' ) ) return;
			const sku = skus[ nameEl.textContent.trim() ];
			if ( ! sku ) return;
			const skuEl = document.createElement( 'span' );
			skuEl.className = 'order-summary-item-sku';
			skuEl.textContent = sku;
			nameEl.prepend( skuEl );
		} );
	}

	const observer = new MutationObserver( () => {
		const titleText = document.querySelector( '.wc-block-components-checkout-order-summary__title-text' );
		if ( titleText ) {
			addEditTooltip( titleText );
		}
		linkProductNamesToCategories();
		prefixProductNamesWithSku();
	} );
	observer.observe( checkoutNode, { childList: true, subtree: true } );
} );

domReady( () => {
	const payment_choice = document.querySelector( '.woocommerce .woocommerce-order table.widefat.striped td p' );
	if ( payment_choice ) {
		var payment_method_xpath = "//td[text()='On File Payment']";
		var payment_method = document.evaluate(payment_method_xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;

		if ( payment_method ) {
			payment_method.insertAdjacentElement( 'beforeend', payment_choice );
		}
	}
} );
